var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "media-gallery",
      class: {
        "media-gallery_office":
          _vm.categoryProps === _vm.config.rootcategories.biuro
      }
    },
    [
      _vm.isOnline
        ? _c(
            "div",
            {
              staticClass: "relative w-100",
              class: {
                gallery_office:
                  _vm.categoryProps === _vm.config.rootcategories.biuro
              }
            },
            [
              _vm.isZoomOpen
                ? _c("product-gallery-overlay", {
                    attrs: {
                      "current-slide": _vm.currentSlide,
                      "product-name": _vm.product.name,
                      gallery: _vm.gallery
                    },
                    on: { close: _vm.toggleZoom }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "no-ssr",
                [
                  _vm.showProductGalleryCarousel
                    ? _c("product-gallery-carousel", {
                        attrs: {
                          gallery: _vm.gallery,
                          configuration: _vm.configuration,
                          "product-name": _vm.product.name,
                          propOffice: _vm.product.catalog
                        },
                        on: {
                          toggle: _vm.openOverlay,
                          close: _vm.onEscapePress,
                          loaded: function($event) {
                            _vm.carouselLoaded = true
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c("product-image-cloudfront", { attrs: { image: _vm.offline } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }